import styled from 'styled-components'

export const Card = styled.div`
  background-color: var(--color-background);
  margin: 15px 15px 30px 15px;
  border-radius: 5px;
  color: var(--color-font);
`
